import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import { connect } from 'react-redux';
import { withModel } from '../data-providers/model';
import withProductCustomisation from './withProductCustomisation';
import {
  addToCart,
  editCartItem,
  removeCartItem,
} from 'src/client/js/store/thunks/cart';
import { getStatus } from 'src/client/js/store/selectors/cart';
import { skus } from 'src/common/config/product';
import get from 'lodash/get';
import isString from 'lodash/isString';

const transformCharacterSelection = item => {
  const characterSelection = get(item, 'customisations.characterSelection');

  if (characterSelection && !isString(characterSelection)) {
    item.customisations.characterSelection = JSON.stringify(characterSelection);
  }

  return item;
};

const withCart = compose(
  withProductCustomisation,
  withModel,
  connect(
    state => ({
      status: getStatus(state),
    }),
    (dispatch, props) => ({
      add: (items = null, redirect = true) => {
        const itemFromStore = {
          productId: skus[props.productKey],
          customisations: props.productCustomisation,
        };
        const newItems = items || [itemFromStore]; // needs to be an array
        // falls back to product customisations in the redux store if no item is passed in as an arg

        const payload = {
          items: newItems.map(item => transformCharacterSelection(item))
        };

        dispatch(addToCart(payload, props.model.countryModel, redirect, window));
      },
      edit: id => {
        const item = {
          id,
          customisations: props.productCustomisation,
        };
        return dispatch(editCartItem(item));
      },
      remove: itemId => dispatch(removeCartItem(itemId, props.model.countryModel)),
    }),
  ),
  mapProps(({ status, add, edit, remove, ...props }) => ({
    ...props,
    cart: {
      status,
      add,
      edit,
      remove,
    },
  })),
);

export default withCart;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withCart.js